import { Component } from '@angular/core';

@Component({
  selector: 'app-private',
  template: `<ion-router-outlet></ion-router-outlet>`
})
export class PrivateComponent {

  constructor() {}

}
